function anchorInit() {
  anchorHash();
  const els = document.querySelectorAll('.jsAnchor');
  els.forEach(el => {
    anchorClick(el, els);
  });
}

let savedHash = window.location.hash;
if (savedHash) {
    history.replaceState(null, null, window.location.pathname + window.location.search);
}

function anchorHash() {
  const el = document.getElementById(decodeURIComponent(savedHash.slice(1)));
  if (!el) return;
  window.scrollTo(0, 0);
  anchorMove(el);
}

function anchorMove(el) {
  if(el === null) {
    $('html, body').stop().animate({ scrollTop: 0 }, 500);
  }else {
    if(el != undefined) {
      const stickyH = el.dataset.type === 'sticky' ? 152 : 0;
      const hasPageKatari = document.getElementsByClassName('pageKatari').length > 0;
      const hasPageHowto = document.getElementById('pageHowto') !== null;
      const hasPageSpecialList = document.getElementById('pageSpecialList') !== null;
      const hasPageAreaList = document.getElementsByClassName('pageAreaList') !== null;
      const hasPageTraining = document.getElementById('training') !== null;
      const hasPageTrainingProgram = document.getElementById('trainingProgram') !== null;
      const hasPageFAQ = document.getElementById('pageFaq') !== null;
      const hasPageGenre = document.getElementById('pageGenre') !== null;
      const hasPageHowToOnline = document.getElementById('pageHowToOnline') !== null;
      const hasPageCustomerCase = document.getElementById('pageCustomerCase') !== null;
      const hasPageOptionMenu = document.getElementById('pageOptionMenu') !== null;

      const howtoOffset = hasPageHowto ? (innerWidth <= 992 ? -2 : 81) : (innerWidth <= 992 ? 123 : 76);

      const specialListOffset = hasPageSpecialList ? (innerWidth <= 992 ? -290 : -148) : 0;

      const areaListOffset = hasPageTraining || hasPageTrainingProgram
        ? 0
        : (hasPageAreaList ? (innerWidth <= 992 ? 10 : -60) : 0);

      const trainingProgramOffset = hasPageTrainingProgram
        ? (document.getElementById('jsAnchors')?.offsetHeight ?? 0)
        : 0;

      const trainingSidebarEl = document.querySelector('.ct-sidebar');
      const trainingPcSidebarOffset = (hasPageTraining || hasPageTrainingProgram) && innerWidth > 768 && trainingSidebarEl
        ? (Number.parseFloat(getComputedStyle(trainingSidebarEl).top) || 0)
        : null;

      const faqOffset = hasPageFAQ ? (innerWidth <= 992 ? -10 : 0) : 0;

      const genreOffset = hasPageGenre ? (innerWidth <= 992 ? 72 : 175) : 0;

      const howToOnlineOffset = hasPageHowToOnline ? (innerWidth <= 992 ? -20 : 140) : 0;

      const optionMenuOffset = hasPageOptionMenu ? (innerWidth <= 992 ? 38 : 114) : 0;

      const getOffsetTop = () => {
        let offsetTop = el.getBoundingClientRect().top + scrollY - stickyH;
        if (hasPageKatari) {
          const katariHeaderHeight = document.querySelector('.k-header')?.offsetHeight
            ?? (innerWidth <= 769 ? 44 : 80);
          offsetTop -= katariHeaderHeight;
        } else if (hasPageCustomerCase) {
          offsetTop -= innerWidth <= 992 ? 123 : 76;
        } else if (trainingPcSidebarOffset !== null) {
          offsetTop -= trainingPcSidebarOffset;
        } else {
          offsetTop -= howtoOffset + specialListOffset + areaListOffset + trainingProgramOffset + faqOffset + genreOffset + howToOnlineOffset + optionMenuOffset;
        }
        if(stickyNavEl) {
          offsetTop -= stickyNavEl.offsetHeight;
        }
        return offsetTop;
      };
      $('html, body').stop().animate({ scrollTop: getOffsetTop() }, 500, () => {
        if (!hasPageKatari) return;
        [0, 100, 300].forEach(delay => {
          window.setTimeout(() => window.scrollTo(0, getOffsetTop()), delay);
        });
      });
    }
  }
}

function normalizePath(path) {
  return path === '/' ? path : path.replace(/\/$/, '');
}

function anchorClick(el, els) {
  el.addEventListener('click', (e) => {
    const href = el.getAttribute('href');
    const destination = href ? new URL(href, location.href) : null;
    const isSamePage = destination
      ? normalizePath(destination.pathname) === normalizePath(location.pathname) && destination.search === location.search
      : true;
    if (isSamePage) {
      anchorMove(document.getElementById(el.dataset.anchor));
      if (el.dataset.type === 'sticky') {
        els.forEach(el => el.classList.remove('current'));
        el.classList.add('current');
      }
      e.preventDefault();
    }
  });
}

function addSticky() {
  if (stickyNavEl && stickyNavWrapEl) {
    stickyNavWrapEl.style.height = `${stickyNavWrapEl.offsetHeight}px`;
    const wrapTop = stickyNavWrapEl.getBoundingClientRect().top;
    if (wrapTop <= 78) {
      stickyNavEl.classList.add('fixed');
    } else {
      stickyNavEl.classList.remove('fixed');
    }
  }
}

let stickyNavWrapEl = document.getElementById('jsStickyNavWrap');
let stickyNavEl = document.getElementById('jsStickyNav');

window.addEventListener('load', () => {
  stickyNavWrapEl = document.getElementById('jsStickyNavWrap');
  stickyNavEl = document.getElementById('jsStickyNav');
  addSticky();
  anchorInit();
  const els = document.querySelectorAll('.msg-err')[0];
  anchorMove(els);
});
window.addEventListener('scroll', () => {
  addSticky();
});

window.addEventListener('resize', () => {
  anchorHash();
});

window.addEventListener('hashchange', () => {
  anchorHash();
});

document.querySelectorAll('.jsAnchor1').forEach(link => {
    link.addEventListener('click', function(e) {
        const destination = this.getAttribute('href');

        if (destination && destination.includes('#')) {
            const targetId = destination.split('#')[1];
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                e.preventDefault();
                const headerHeight = document.querySelector('header').offsetHeight;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    });
});
